export default class EnrolmentWelcomeViewModel {
    academicYear: string | undefined = undefined;
    studentReferenceNumber: string | undefined = undefined;
    dateofBirth: Date | undefined = undefined;
    postcode: string | undefined = undefined;
    postcodeIn: string | undefined = undefined;
    postcodeOut: string | undefined = undefined;
}
